import { observer } from "mobx-react"
import { Col, Flex, Form, FormInstance, Input, Row, Select } from "antd"

import { ProjectsCollection } from "@src/app/ProjectsCollection"
import { PaymentLinkFormAmount } from "@src/pages/paymentLinksCreate/ui/PaymentLinkFormAmount"
import { PaymentLinkFormTimeLimit } from "@src/pages/paymentLinksCreate/ui/PaymentLinkFormTimeLimit"

type PaymentLinkFormProps = {
  form: FormInstance
  isLoading: boolean
  projects: ProjectsCollection
}
export const PaymentLinkForm = observer(
  ({ form, isLoading, projects }: PaymentLinkFormProps) => {
    return (
      <Form
        disabled={projects.isLoading || isLoading}
        form={form}
        id="GENERATED_ID_PAYMENTLINKFORM_FORM_VOID_1"
        layout={"vertical"}
        name="paymentLink"
        style={{ height: "100%" }}
      >
        <Flex gap={16} vertical>
          <Row gutter={32}>
            <Col span={12}>
              <Form.Item
                id="GENERATED_ID_PAYMENTLINKFORM_TSX_FORM.ITEM_VOID_1"
                label="Email"
                name="customer_email"
                rules={[
                  {
                    message: "Must be a valid email address",
                    type: "email",
                  },
                  {
                    message: "Please input your Email",
                    required: true,
                  },
                ]}
              >
                <Input placeholder="Enter email" />
              </Form.Item>
            </Col>

            <Col span={12}>
              <PaymentLinkFormAmount />
            </Col>
          </Row>
          <Row gutter={32}>
            <Col span={12}>
              <Form.Item
                id="GENERATED_ID_PAYMENTLINKFORM_TSX_FORM.ITEM_VOID_2"
                label="Project"
                name="project_id"
                rules={[
                  { message: "Please select at least one", required: true },
                ]}
              >
                <Select
                  loading={projects.isLoading}
                  options={projects.selectOptions}
                  placeholder="Select one of your projects from the list"
                />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item
                id="GENERATED_ID_PAYMENTLINKFORM_TSX_FORM.ITEM_VOID_3"
                label="Customer name"
                name="customer_name"
                rules={[{ message: "Please input name", required: true }]}
              >
                <Input placeholder="Enter customer name" />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={32}>
            <Col span={12}>
              <Form.Item
                id="GENERATED_ID_PAYMENTLINKFORM_TSX_FORM.ITEM_VOID_4"
                label="Memo"
                name="memo"
              >
                <Input placeholder="Enter descriptions" />
              </Form.Item>
            </Col>

            <Col span={12} style={{ marginTop: 15 }}>
              <PaymentLinkFormTimeLimit />
            </Col>
          </Row>
        </Flex>
      </Form>
    )
  },
)
